import ModuleBlock from "./ModuleBlock";

export default class PowerSupplyBusSegment extends ModuleBlock {
  constructor(json) {
    super(json);
    this.consumption = PowerSupplyBusSegment.getMappedOrDefault(json, 'consumption', 0, v => parseInt(v));
    this.consumptionWithoutCustom = PowerSupplyBusSegment.getMappedOrDefault(json, 'consumptionWithoutCustom', 0, v => parseInt(v));
    this.maxConsumption = PowerSupplyBusSegment.getMappedOrDefault(json, 'maxConsumption', 0, v => parseInt(v));
  }
}
